import TripCheckoutController from './controllers/checkout/trip-checkout-controller';
import TripCheckoutTravellersController from './controllers/checkout/tripCheckoutTravellersController';
import TripCheckoutCarController from './controllers/checkout/trip-checkout-car-controller';
import TripCheckoutAvailabilityController from './controllers/checkout/tripCheckoutAvailabilityController';
import TripListController from './list/tripListController';
import TripCheckoutRailsController from './controllers/checkout/trip-checkout-rails-controller';
import TripCheckoutEuRailsController from './controllers/checkout/trip-checkout-eurails-controller';
import TripCheckoutAllocationController from './allocation/trip-checkout-allocation-controller';
import TripCheckoutPaymentCodesController from './payment-codes/tripCheckoutPaymentCodesController';
import TripCheckoutPaymentController from './payment/trip-checkout-payment-controller';
import TripDetailsApproveFormController from './controllers/details/tripDetailsApproveFormController';
import TripCheckoutLuggageController from './controllers/checkout/tripCheckoutLuggageController';
import TripCheckoutTermsController from './controllers/checkout/trip-checkout-terms-controller';
import TripCheckoutHotelController from './controllers/checkout/trip-checkout-hotel-controller';
import TripDetailsController from './controllers/details/tripDetailsController';
import TripDetailsSendController from './controllers/details/tripDetailsSendController';
import TripDetailsReviewController from './controllers/details/tripDetailsReviewController';
import TripDetailsRequestChangeController from './controllers/details/tripDetailsRequestChangeController';
import TripDetailsOrderListController from './controllers/details/tripDetailsOrderListController';
import TripDetailsTravellersController from './controllers/details/tripDetailsTravellersController';
import TripCheckoutCarbonController from './controllers/checkout/trip-checkout-carbon-controller';

import checkoutTemplate from './templates/checkout.tmpl.html';
import listTemplate from './templates/list.tmpl.html';
import listTableTemplate from './templates/partials/list/list.table.tmpl.html';
import rejectedTemplate from './templates/rejected.tmpl.html';
import detailsTemplate from './templates/details.tmpl.html';
import detailsOrderListTemplate from './templates/partials/details/details.orderList.tmpl.html';
import detailsRequestChangeTemplate from './templates/partials/details/details.requestChange.tmpl.html';
import detailsSendTemplate from './templates/partials/details/details.send.tmpl.html';
import detailsReviewTemplate from './templates/partials/details/details.review.tmpl.html';
import detailsTravellersTemplate from './templates/partials/details/details.travellers.tmpl.html';
import detailsApproveFormTemplate from './templates/partials/details/details.approveForm.tmpl.html';
import checkoutTravellersTemplate from './templates/partials/checkout/checkout.travellers.tmpl.html';
import checkoutFlightsTemplate from './templates/partials/checkout/checkout.flights.tmpl.html';
import checkoutRailsTemplate from './templates/partials/checkout/checkout.rails.tmpl.html';
import checkoutEuRailsTemplate from './templates/partials/checkout/checkout.eurails.tmpl.html';
import checkoutHotelsTemplate from './templates/partials/checkout/checkout.hotels.tmpl.html';
import checkoutCarsTemplate from './templates/partials/checkout/checkout.cars.tmpl.html';
import checkoutAllocationTemplate from './allocation/checkout.allocation.tmpl.html';
import checkoutPaymentCodesTemplate from './payment-codes/checkout.paymentCodes.tmpl.html';
import checkoutTermsHoldTemplate from './templates/partials/checkout/checkout.terms.hold.tmpl.html';
import checkoutTermsBookTemplate from './templates/partials/checkout/checkout.terms.book.tmpl.html';
import checkoutAvailabilityTemplate from './templates/partials/checkout/checkout.availability.tmpl.html';
import checkoutLuggageTemplate from './templates/partials/checkout/checkout.luggage.tmpl.html';
import checkoutCarbonTemplate from './templates/partials/checkout/checkout.carbon.tmpl.html';

export const tripStates = {
    MAIN: 'main.trip',
    CHECKOUT: 'main.trip.checkout',
    TRIP_LIST: 'main.trip.list',
    TRIP_DETAILS: 'main.trip.details',
    TRIP_REJECTED: 'main.trip.rejected',
};

export default function TripRoutes($stateProvider) {
    'ngInject';

    $stateProvider
        .state(tripStates.MAIN, {
            url: '/trip',
            template: '<ui-view></ui-view>',
        })

        .state(tripStates.CHECKOUT, {
            url: '/:id/:department/checkout?verificationId',
            params: {
                department: {squash: true},
                tripValidation: null,
                newRailRecommendationId: null,
                rebook: null,
            },
            resolve: {
                tripId: function($stateParams) {
                    'ngInject';
                    return $stateParams.id;
                },
                tripDepartmentId: function($stateParams) {
                    'ngInject';
                    return parseInt($stateParams.department, 10);
                },
                travelFusionCardValidation: function($stateParams, tripData, tripUtils, tripAPI) {
                    'ngInject';
                    if ($stateParams.verificationId) {
                        return tripAPI.travelFusionProcessCreditCard($stateParams.verificationId)
                            .then(({data}) => {
                                if (!tripUtils.openCardValidationUrls($stateParams.id)) {
                                    return data;
                                }
                            });
                    }
                    return true;

                },
                tripData: function($q, $stateParams, tripFactory, tripOptionsService, tripId) {
                    'ngInject';
                    return $q.all([
                        tripOptionsService.initAdultTitles(),
                        tripOptionsService.initCallingCodes(),
                        tripOptionsService.initCountries(),
                    ]).then(function() {
                        return tripFactory.getTripCheckoutData(tripId);
                    });
                },
                tripDetails: function($q, $stateParams, tripId, tripFactory, tripDepartmentId, tripOptionsService) {
                    'ngInject';
                    return $q.all([
                        tripOptionsService.initAdultTitles(),
                        tripOptionsService.initCallingCodes(),
                        tripOptionsService.initCountries(),
                    ])
                        .then(() => tripFactory.tripDetails(tripId, false, tripDepartmentId));
                },
                tripValidation: function($stateParams, tripFactory, tripId, tripDetails) {
                    'ngInject';
                    return $stateParams.tripValidation || tripFactory.validateTrip(tripId, tripDetails);
                },
                fareTypesInited: function(flightFareService) {
                    'ngInject';
                    return flightFareService.getFareTypes();
                },
            },
            onEnter: function($rootScope) {
                'ngInject';
                $rootScope.pageHeading = 'Checkout';
            },
            views: {
                '': {
                    template: checkoutTemplate,
                    controller: TripCheckoutController,
                    controllerAs: 'tripCheckoutCtrl',
                },
                [`travellers@${tripStates.CHECKOUT}`]: {
                    template: checkoutTravellersTemplate,
                    controller: TripCheckoutTravellersController,
                    controllerAs: 'tripCheckoutTravellersCtrl',
                },
                [`allocation@${tripStates.CHECKOUT}`]: {
                    template: checkoutAllocationTemplate,
                    controller: TripCheckoutAllocationController,
                    controllerAs: 'tripCheckoutAllocationCtrl',
                    bindToController: true,
                },
                [`luggage@${tripStates.CHECKOUT}`]: {
                    template: checkoutLuggageTemplate,
                    controller: TripCheckoutLuggageController,
                },
                [`payment@${tripStates.CHECKOUT}`]: {
                    template: '<ng-include src="getTemplateUrl()"/>',
                    controller: TripCheckoutPaymentController,
                    controllerAs: 'tripCheckoutPaymentCtrl',
                },
                [`paymentCodes@${tripStates.CHECKOUT}`]: {
                    template: checkoutPaymentCodesTemplate,
                    controller: TripCheckoutPaymentCodesController,
                    controllerAs: 'tripCheckoutPaymentCodesCtrl',
                },
                [`termsBook@${tripStates.CHECKOUT}`]: {
                    template: checkoutTermsBookTemplate,
                    controller: TripCheckoutTermsController,
                    controllerAs: 'tripCheckoutTermsController',
                },
                [`termsHold@${tripStates.CHECKOUT}`]: {
                    template: checkoutTermsHoldTemplate,
                    controller: TripCheckoutTermsController,
                    controllerAs: 'tripCheckoutTermsController',
                },
                [`availability@${tripStates.CHECKOUT}`]: {
                    template: checkoutAvailabilityTemplate,
                    controller: TripCheckoutAvailabilityController,
                    controllerAs: 'tripCheckoutAvailabilityCtrl',
                },
                [`flights@${tripStates.CHECKOUT}`]: {
                    template: checkoutFlightsTemplate,
                    controller: function($scope, flightsUtils) {
                        'ngInject';
                        $scope.isTrain = flightsUtils.isItemTrain;
                    },
                },
                [`hotels@${tripStates.CHECKOUT}`]: {
                    template: checkoutHotelsTemplate,
                    controller: TripCheckoutHotelController,
                    controllerAs: 'tripCheckoutHotelCtrl',
                },
                [`cars@${tripStates.CHECKOUT}`]: {
                    template: checkoutCarsTemplate,
                    controller: TripCheckoutCarController,
                    controllerAs: 'tripCheckoutCarCtrl',
                },
                [`rails@${tripStates.CHECKOUT}`]: {
                    template: checkoutRailsTemplate,
                    controller: TripCheckoutRailsController,
                    controllerAs: 'tripCheckoutRailsCtrl',
                },
                [`eurails@${tripStates.CHECKOUT}`]: {
                    template: checkoutEuRailsTemplate,
                    controller: TripCheckoutEuRailsController,
                    controllerAs: 'tripCheckoutEuRailsCtrl',
                },
                [`carbon@${tripStates.CHECKOUT}`]: {
                    template: checkoutCarbonTemplate,
                    controller: TripCheckoutCarbonController,
                },
            },
        })

        .state(tripStates.TRIP_LIST, {
            url: '/list',
            resolve: {
                tripStatuses: function($rootScope, $state, tripAPI) {
                    'ngInject';
                    if ($rootScope.readOnlyMode) {
                        $state.go('login');
                    }
                    return tripAPI.getTripStatuses();
                },
            },
            views: {
                '': {
                    template: listTemplate,
                    controller: TripListController,
                    controllerAs: 'tripListCtrl',
                },
                'table@main.trip.list': {
                    template: listTableTemplate,
                },
            },
            onEnter: function($rootScope) {
                'ngInject';
                $rootScope.pageHeading = 'Trip List';
            },
        })

        .state(tripStates.TRIP_DETAILS, {
            url: '/:id/:department/details',
            params: {
                department: {squash: true},
            },
            resolve: {
                isVisibleSendBlock: function(tripFactory) {
                    'ngInject';
                    return tripFactory.isVisibleSendBlock();
                },
                isVisibleVerifyBlock: function(tripFactory) {
                    'ngInject';
                    return tripFactory.isVisibleVerifyBlock();
                },
                tripId: function($stateParams) {
                    'ngInject';
                    return $stateParams.id;
                },
                tripDepartmentId: function($stateParams) {
                    'ngInject';
                    return parseInt($stateParams.department, 10);
                },
                tripDetails: function($q, sessionService, tripId, tripFactory, tripOptionsService, tripDepartmentId) {
                    'ngInject';
                    if (sessionService.getSessionItem('readOnlyMode')) {
                        return tripFactory.tripDetails(tripId, false, tripDepartmentId);
                    }

                    return $q.all([
                        tripOptionsService.initAdultTitles(),
                        tripOptionsService.initCallingCodes(),
                        tripOptionsService.initCountries(),
                    ]).then(() => tripFactory.tripDetails(tripId, false, tripDepartmentId));
                },
                fareTypesInited: function(flightFareService) {
                    'ngInject';
                    return flightFareService.getFareTypes();
                },
            },
            views: {
                '': {
                    template: detailsTemplate,
                    controller: TripDetailsController,
                    controllerAs: 'tripDetailsCtrl',
                },
                [`send@${tripStates.TRIP_DETAILS}`]: {
                    template: detailsSendTemplate,
                    controller: TripDetailsSendController,
                },
                [`review@${tripStates.TRIP_DETAILS}`]: {
                    template: detailsReviewTemplate,
                    controller: TripDetailsReviewController,
                    controllerAs: 'tripDetailsReviewCtrl',
                },
                [`requestChange@${tripStates.TRIP_DETAILS}`]: {
                    template: detailsRequestChangeTemplate,
                    controller: TripDetailsRequestChangeController,
                    controllerAs: 'tripDetailsRequestChangeCtrl',
                },
                [`orderList@${tripStates.TRIP_DETAILS}`]: {
                    template: detailsOrderListTemplate,
                    controller: TripDetailsOrderListController,
                    controllerAs: 'tripDetailsOrderListCtrl',
                },
                [`travellers@${tripStates.TRIP_DETAILS}`]: {
                    template: detailsTravellersTemplate,
                    controller: TripDetailsTravellersController,
                    controllerAs: 'tripDetailsTravellersCtrl',
                },
                [`approveForm@${tripStates.TRIP_DETAILS}`]: {
                    template: detailsApproveFormTemplate,
                    controller: TripDetailsApproveFormController,
                    controllerAs: 'tripDetailsApproveFormCtrl',
                },
            },
            onEnter: ['$rootScope', function($rootScope) {
                $rootScope.pageHeading = 'Trip Details';
            }],
        })

        .state(tripStates.TRIP_REJECTED, {
            url: '/:id/rejected',
            resolve: {
                isVisibleSendBlock: function(tripFactory) {
                    'ngInject';
                    return tripFactory.isVisibleSendBlock();
                },
                tripId: function($stateParams) {
                    'ngInject';
                    return $stateParams.id;
                },
                tripDetails: function(tripId, tripFactory) {
                    'ngInject';
                    return tripFactory.tripDetails(tripId);
                },
                tripData: function(tripFactory, triAPI, tripOptionsService, tripId, $q) {
                    'ngInject';
                    if (tripFactory.isHash(tripId)) {
                        return;
                    }
                    return $q.all([
                        tripOptionsService.initAdultTitles(),
                        tripOptionsService.initCallingCodes(),
                        tripOptionsService.initCountries(),
                    ]).then(() => tripFactory.getTripCheckoutData(tripId));
                },
            },
            views: {
                '': {
                    template: rejectedTemplate,
                    controller: TripDetailsController,
                    controllerAs: 'tripDetailsCtrl',
                },
                [`send@${tripStates.TRIP_DETAILS}`]: {
                    template: detailsSendTemplate,
                    controller: TripDetailsSendController,
                },
                [`requestChange@${tripStates.TRIP_DETAILS}`]: {
                    template: detailsRequestChangeTemplate,
                    controller: TripDetailsRequestChangeController,
                },
                [`orderList@${tripStates.TRIP_DETAILS}`]: {
                    template: detailsOrderListTemplate,
                    controller: TripDetailsOrderListController,
                    controllerAs: 'tripDetailsOrderListCtrl',
                },
                [`travellers@${tripStates.TRIP_DETAILS}`]: {
                    template: detailsTravellersTemplate,
                    controller: TripDetailsTravellersController,
                },
                [`approveForm@${tripStates.TRIP_DETAILS}`]: {
                    template: detailsApproveFormTemplate,
                    controller: TripDetailsApproveFormController,
                    controllerAs: 'tripDetailsApproveFormCtrl',
                },
            },
            onEnter: function($rootScope) {
                'ngInject';
                $rootScope.pageHeading = 'Trip Details';
            },
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-routes.js